import { render, staticRenderFns } from "./DeveloperGamesTemp.vue?vue&type=template&id=497bb322&scoped=true"
import script from "./DeveloperGamesTemp.vue?vue&type=script&lang=js"
export * from "./DeveloperGamesTemp.vue?vue&type=script&lang=js"
import style0 from "./DeveloperGamesTemp.vue?vue&type=style&index=0&id=497bb322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497bb322",
  null
  
)

export default component.exports